<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzTitle="Tokens" nzSubtitle=" - Lista de tokens cadastrados.">
        <nz-page-header-extra>
            <button nz-button nzType="primary" routerLink="lancamento"><i nz-icon nzType="plus"></i> Gerar Token</button>
        </nz-page-header-extra>
    </nz-page-header>

    <div nz-row>

        <div nz-col nzSpan="24">
            <nz-divider></nz-divider>
        </div>
        <div nz-col nzSpan="19" style="margin-bottom:10px;">
            <nz-input-group nzCompact nzSearch [nzAddOnAfter]="suffixIconButton">
                <input type="text" [(ngModel)]="search" style="min-width: 500px!important;" nz-input placeholder="Pesquise pelo nome do usuário, token ou nome do token" />

            </nz-input-group>
            <ng-template #suffixIconButton>
                <button nz-button nzType="primary" (click)="searchTokens()" nzSearch><i nz-icon nzType="search"></i></button>
            </ng-template>
        </div>
        <div nz-col nzSpan="4" style="margin-left: 10px;">
            <button nzBlock nz-button nzType="danger" *ngIf="!isVisibleCancelFiltro" disabled (click)="removerFiltro()"><i nz-icon nzType="close-circle" nzTheme="outline"></i> Cancelar Pesquisa</button>
            <button nzBlock nz-button nzType="danger" *ngIf="isVisibleCancelFiltro" (click)="removerFiltro()"><i nz-icon nzType="close-circle" nzTheme="outline"></i> Cancelar Pesquisa</button>
        </div>

        <div nz-col nzSpan="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="tokens" [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Usuário</th>
                        <th>Nome</th>
                        <th>Token</th>
                        <th>Último Acesso</th>
                        <th>Criado em</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td>{{data?.id}}</td>
                            <td><span nz-icon nzType="user" nzTheme="outline"></span> {{data?.user?.id}} - {{data?.user?.name}}</td>
                            <td>{{data?.name}}</td>
                            <td>
                                <p style="margin-bottom: 3px;  word-break: break-all;" nz-typography nzCopyable [nzContent]="data?.decrypt_token"></p>
                                <strong>Habilidades: </strong> {{data?.abilities.join(', ')}}
                            </td>                            
                            <td>
                                
                                <span *ngIf="data?.last_used_at">{{data?.last_used_at | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                <em style="color:gray;" *ngIf="!data?.last_used_at">Nunca Utilizado</em>
                            </td>
                            <td>{{data?.created_at | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                            <td>
                                <button nz-button nz-dropdown [nzDropdownMenu]="menu">Operações<i nz-icon
                                        nzType="down"></i></button>
                                <nz-dropdown-menu #menu="nzDropdownMenu">
                                    <ul nz-menu>

                                        <li nz-menu-item>
                                            <a routerLink="lancamento/{{data.id}}"><span nz-icon nzType="edit" nzTheme="outline"></span> Editar</a>
                                        </li>
                                        <li nz-menu-item>
                                            <a (click)="enviarEmail(data?.id)"><span nz-icon nzType="mail" nzTheme="outline"></span> Enviar Token por E-mail</a>
                                        </li>


                                        <li nz-menu-item>
                                            <a
                                            nz-popconfirm
                                            nzPopconfirmTitle="Deseja realmente remover o token?"
                                            nzOkText="Sim"
                                            nzCancelText="Não"
                                            (nzOnConfirm)="excluir(data?.id)"
                                            style="color:#f63849;"><span nz-icon nzType="delete" nzTheme="outline"></span> Excluir</a>
                                        </li>
                                    </ul>
                                </nz-dropdown-menu>
                            </td>
                        </tr>

                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>